import React, { useMemo, useState } from 'react';
import _ from 'lodash';

import { Trans, useTranslation } from 'react-i18next';
import { Button, message, Modal, Radio, Table } from 'antd';
import api from '@services/api';
import { HiOutlineDocument } from 'react-icons/hi';
import { BiBlock, BiCheckCircle } from 'react-icons/bi';
import { TActionProps } from '../types';

function ContractBlockCRR({
  selectedContracts,
  visibleState,
  onFinish,
}: TActionProps) {
  const [allowDisallow, setAllowDisallow] = useState('makeallow');
  const [modalActionVisible, setModalActionVisible] = visibleState;
  const [isLoading, setIsLoading] = useState(false);

  const separatedContracts = useMemo(() => {
    if (selectedContracts) {
      // 0 - not allowed
      // 1 - allowed
      return _.groupBy(selectedContracts, 'flagBlockCRR');
    }
    return undefined;
  }, [selectedContracts]);

  useMemo(() => {
    if (
      separatedContracts &&
      !separatedContracts['0'] &&
      separatedContracts['1']
    ) {
      setAllowDisallow('makedisallow');
    }
  }, [separatedContracts]);

  const { t: translate } = useTranslation(['customer-contracts']);

  const handleOk = async () => {
    setIsLoading(true);

    try {
      await api.put(
        'service-proxy/contracts/customer/updateFlagBlockCrr',
        {},
        {
          params: {
            assetNumberList:
              // eslint-disable-next-line no-nested-ternary
              allowDisallow === 'makeallow'
                ? separatedContracts?.['0'].map(e => e.assetNumber).toString()
                : separatedContracts?.['1'].map(e => e.assetNumber).toString(),
            flagBlockCRR: allowDisallow === 'makeallow' ? 'true' : 'false',
          },
        },
      );
      message.success(translate('modal-actions.submit-success'));
    } catch (err: any) {
      message.error(translate('modal-actions.submit-error'));
    }
    setIsLoading(false);
    await onFinish();
    setModalActionVisible(false);
  };
  const handleCloseModal = async () => {
    setModalActionVisible(false);
  };
  return (
    <Modal
      title={translate('modal-actions.visibility')}
      open={modalActionVisible}
      onCancel={handleCloseModal}
      footer={
        <Button
          type="primary"
          onClick={() => handleOk()}
          disabled={isLoading}
          loading={isLoading}
        >
          {translate('modal-actions.confirm')}
        </Button>
      }
    >
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          gridGap: '20px',
          color: '#8C9696',
        }}
      >
        <div className="network-block-radio">
          <Radio.Group
            name="radiogroup"
            defaultValue={20}
            style={{ display: 'flex', justifyContent: 'center' }}
            value={allowDisallow}
            onChange={e => {
              if (e.target?.value) {
                setAllowDisallow(e.target.value);
              }
            }}
          >
            <Radio.Button
              value="makeallow"
              className="block-card-option"
              disabled={!separatedContracts?.['0']}
            >
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                }}
              >
                <span style={{ position: 'relative', lineHeight: '1' }}>
                  <HiOutlineDocument className="signal-icon" />
                  <BiCheckCircle className="unblock-icon" />
                </span>
              </div>
              <div style={{ lineHeight: '1' }}>
                {translate('modal-actions.steps.crr-block.allow-blocking')}
              </div>
            </Radio.Button>
            <Radio.Button
              value="makedisallow"
              className="block-card-option"
              disabled={!separatedContracts?.['1']}
            >
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                }}
              >
                <span style={{ position: 'relative', lineHeight: '1' }}>
                  <HiOutlineDocument className="signal-icon" />
                  <BiBlock className="block-icon" />
                </span>
              </div>
              <div style={{ lineHeight: '1' }}>
                {translate('modal-actions.steps.crr-block.disallow-blocking')}
              </div>
            </Radio.Button>
          </Radio.Group>
        </div>

        {separatedContracts && (
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              gridGap: '20px',
              width: '100%',
            }}
          >
            <Trans
              t={translate}
              i18nKey="modal-actions.steps.visibility.warning-devices"
              values={{
                action:
                  allowDisallow === 'makeallow'
                    ? translate('modal-actions.steps.crr-block.allow-blocking')
                    : translate(
                        'modal-actions.steps.crr-block.disallow-blocking',
                      ),
                quantity:
                  allowDisallow === 'makeallow'
                    ? separatedContracts?.['0'] &&
                      separatedContracts?.['0'].length
                    : separatedContracts?.['1'] &&
                      separatedContracts?.['1'].length,
              }}
            >
              <b style={{ color: 'var(--primary-color)' }}>
                {allowDisallow === 'makeallow'
                  ? translate('modal-actions.steps.crr-block.allow-blocking')
                  : translate(
                      'modal-actions.steps.crr-block.disallow-blocking',
                    )}
              </b>

              <b style={{ color: 'var(--primary-color)' }}>
                {allowDisallow === 'makeallow'
                  ? separatedContracts?.['0'] &&
                    separatedContracts?.['0'].length
                  : separatedContracts?.['1'] &&
                    separatedContracts?.['1'].length}
              </b>
            </Trans>

            <div>
              <Table
                className="block-crr-table"
                rowKey={record => record.id}
                dataSource={
                  allowDisallow === 'makeallow'
                    ? separatedContracts?.['0']
                    : separatedContracts?.['1']
                }
                size="small"
                columns={[
                  {
                    key: 'assetNumber',
                    title: () => translate('title'),
                    dataIndex: 'assetNumber',
                    width: 100,
                  },
                ]}
                pagination={false}
                scroll={{ y: 240 }}
              />
            </div>
          </div>
        )}
      </div>
    </Modal>
  );
}

export default ContractBlockCRR;
